module.exports = __webpack_public_path__ + "img/167.f96a8ab3.jpg";